// Helpers for reading the post-migration (UX-17777) Contentful `landingPage`
// data. Several hero / image-card fields were moved onto linked entries
// (`reference` -> Page Hero Banner, `imageCardSection` -> Image Card Section),
// and a new `imageBand` array of `image` entries was added.
//
// Linked entries are resolved inline by the Contentful REST client, so a linked
// entry looks like `{ sys, fields }` and an array link is an array of those.
// All three links are optional, so each helper falls back safely when absent.

// Read the linked Page Hero Banner fields (landingPage.reference).
// Returns {} when the link is absent.
export const getPageHeroBannerFields = (contentfulData) =>
	contentfulData?.reference?.fields ?? {};

// Read the linked Image Card Section fields (landingPage.imageCardSection).
// Returns {} when the link is absent.
export const getImageCardSectionFields = (contentfulData) =>
	contentfulData?.imageCardSection?.fields ?? {};

// Read the imageBand entries (landingPage.imageBand). Always returns an array.
export const getImageBandItems = (contentfulData) =>
	Array.isArray(contentfulData?.imageBand) ? contentfulData.imageBand : [];

// Normalise a single image entry (from `imageBand`) into renderable sources.
// Two content types are supported:
//  - `image` (most brands): `largeDeviceImage` (desktop) + `smallDeviceImage`
//    (mobile) asset links.
//  - `Page Width Image` (FOX / BON): `defaultImage` (desktop) + `mobileImage`
//    (mobile) asset links.
// Older/direct-URL shapes are also supported as fallbacks.
export const getImageEntrySources = (entry) => {
	const fields = entry?.fields ?? {};
	// `image` content type: largeDeviceImage (desktop) / smallDeviceImage (mobile).
	const largeAsset = fields.largeDeviceImage?.fields;
	const smallAsset = fields.smallDeviceImage?.fields;
	// `Page Width Image` content type (FOX / BON):
	// Default Image (desktop) / Mobile Image (mobile).
	const defaultAsset = fields.defaultImage?.fields;
	const mobileAsset = fields.mobileImage?.fields;
	const desktop =
		largeAsset?.file?.url ||
		defaultAsset?.file?.url ||
		fields.imagePath ||
		fields.image?.fields?.file?.url ||
		'';
	const mobile =
		smallAsset?.file?.url ||
		mobileAsset?.file?.url ||
		fields.mobileImagePath ||
		desktop;
	const alt =
		largeAsset?.title ||
		defaultAsset?.title ||
		fields.image?.fields?.title ||
		fields.altText ||
		fields.entryTitle ||
		'';
	const link = fields.imageLink || '';
	return { desktop, mobile, alt, link };
};
